import { useSearchParams } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { Card } from "../components";
import moviesData from "../data/movies.json"; // lokalni JSON

export const Search = () => {
  const [searchParams] = useSearchParams();
  const queryTerm = searchParams.get("q")?.toLowerCase() || "";

  // filtriramo filmove po title ili original_title
  const movies = moviesData.filter(
    (movie) =>
      movie.title.toLowerCase().includes(queryTerm) ||
      movie.original_title.toLowerCase().includes(queryTerm)
  );

  useTitle(`Search result for ${queryTerm}`);

  return (
    <main>
      <section className="py-7">
        <p className="text-3xl text-gray-700 dark:text-white">
          {movies.length === 0
            ? `No result found for '${queryTerm}'`
            : `Result for '${queryTerm}'`}
        </p>
      </section>
      <section className="max-w-7xl mx-auto py-7">
        <div className="flex justify-start flex-wrap">
          {movies.map((movie) => (
            <Card key={movie.id} movie={movie} />
          ))}
        </div>
      </section>
    </main>
  );
};
